import { inject, Injectable } from '@angular/core'
import { ApiService } from './api.service'
import { map } from 'rxjs'
import { LeaveRequest } from '../modal/leave-request.modal'
import { UpcomingClassImpl } from '../modal/class.modal'
import { ApiLeaveRequest } from '../modal/api.modal'

@Injectable({
  providedIn: 'root'
})
export class LeaveRequestService {
  private api = inject(ApiService)

  getLeaveRequests() {
    return this.api.getLeaveRequests().pipe(
      map((res) => {
        return res.leave_requests.map(LeaveRequestFactory.createLeaveRequest)
      })
    )
  }

  addLeaveReqeust(type: 'casual' | 'sick', classId: number) {
    return this.api.addLeaveRequest(type, classId).pipe(
      map((res) => {
        return LeaveRequestFactory.createLeaveRequest(res.leave_request)
      })
    )
  }
}

class LeaveRequestFactory {
  static createLeaveRequest(req: ApiLeaveRequest): LeaveRequest {
    let sessionType = req.session_type
    switch (sessionType) {
      case 'independent_rider':
        sessionType = 'Independent Ride'
        break
      case 'term_rider':
        sessionType = 'Term Ride'
        break
      case 'group_rider':
        sessionType = 'Group Ride'
        break
    }
    return {
      leaveType: req.type === 'casual' ? 'Casual' : 'Sick',
      applyDate: req.created_at,
      applyStatus: req.status === 'approved' ? 'Approved' : 'Pending',
      clazz: new UpcomingClassImpl({
        venue: req.session_venue_name,
        type: sessionType,
        date: req.session_date,
        time: {
          start: req.session_start_time,
          end: req.session_end_time
        }
      })
    }
  }
}
